import { render, staticRenderFns } from "./Bq.vue?vue&type=template&id=0fc4088e"
import script from "./Bq.vue?vue&type=script&lang=js"
export * from "./Bq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports